<template>
  <div>
    <div class="news_page_banner_out">
      <div class="container">
        <dl class="all_page_banner_txt">
          <dt>招聘详情</dt>
          <dd>news &nbsp;&nbsp; information</dd>
        </dl>
      </div>
    </div>

    <div class="container">
      <div class="row">
        <div class="details_page_con">
          <!-- <div style="float: right;margin-right:5%">
            <a
              style="
                display: block;
                text-align: right;
                margin-right: 5%;
                font-size: 18px;
              "
              @click="returnpage()"
            >
              <span>返回</span>
            </a>
          </div> -->
          <div class="title">
            <h5>{{ newContent.ProductName }}</h5>
            <p>
              <span>时间：{{ newContent.CreateDate }}</span>
              <!-- <span>撰稿人：{{ newContent.author }}</span> -->
            </p>
          </div>
          <div class="details" v-html="newContent.ProductContent" stype="word-wrap: break-word; word-break: break-all;overflow: hidden;"></div>
          <div
            class="details_page_paging"
            style="width: 80%; float: left; margin-top: 10px"
          >
            <!-- <p v-if="newContent.lastId">
              <a @click="getNextAndLast(newContent.lastId)">
                <span>上一篇：</span>{{ newContent.lastTitle }}
              </a>
            </p>
            <p v-if="newContent.nextId">
              <a @click="getNextAndLast(newContent.nextId)">
                <span>下一篇：</span>{{ newContent.nextTitle }}
              </a>
            </p> -->
          </div>
          <!-- <div style="width: 15%; float: left">
            <a
              style="
                display: block;
                text-align: right;
                margin-top: 50px;
                font-size: 18px;
              "
              @click="returnpage()"
            >
              <span>返回</span>
            </a>
          </div> -->
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import "../../static/css/swiper.min.css";
import "../../static/css/nav.css";
import "../../static/css/bootstrap.min.css";
import "../../static/css/animate.min.css";
import "../../static/css/common.css";
import "../../static/css/style.css";
export default {
  data() {
    return {
      newContent: {
        id: 2,
        title: "第三届“泽众杯”山东省卫生职业院校医学检验学生技能大赛举办",
        createDate: "2019-12-04",
        author: "佚名",
        content:
          ' <p>由山东省卫生职业教育指导委员会主办，山东省卫生职业教育指导委员会医学检验技术分委会和莱阳卫生学校承办的第三届“泽众杯”山东省职业院校医学检验技术专业技能竞赛于2018年4月26-27日在山东莱阳召开，全省高职高专、卫生学校办检验专业的学校均排队参加。</p><br /><br /><img src="static/images/img-5.jpg" alt /><br /><br /><br /><p>本届大赛形态学赛项，在莱阳卫生学校机房进行，比赛使用我公司开发的医学检验形态比赛在线考试系统，实现计算机出卷和考试，极大节省评委的工作量</p>',
        nextId: 3,
        nextTitle: "2017年山东省医学检验技术专业教育教学会议召开",
        lastId: 1,
        lastTitle: "第二届山东职业院校医学检验技术专业学生技能大赛召开",
      },
      id: 2,
    };
  },
  methods: {
    getData() {
      var posturl = this.config.baseUrl.pro + "/Base_Product/apiGetBase_Product?id="+this.id;
      axios
        .request({
          url: posturl,
          method: "get",
          changeOrigin: true
        })
        .then((resp) => {
          if (resp.status === 200) {
            // newsList=
            this.newContent = resp.data.Result.Data;
            document.title = this.newContent.ProductName;
          console.log(this.newContent);
          }
        })
        .catch((err) => {
          console.log(err);
          this.$Message.info("新闻列表查询失败");
        });
    },
    getNextAndLast(id) {
      this.id = id;
      this.getData();
    },
    returnpage() {
      this.$router.go(-1);
    },
  },
  mounted() {
    this.id = this.$route.query.id;
    console.log(this.id);
    if (this.id == undefined) {
      this.$router.push({
        name: "product",
      });
    } else {
      this.getData();
    }
  },
};
</script>



// WEBPACK FOOTER //
// src/view/prodetails.vue